import {
    FavoriteBorder as FavoriteBorderIcon,
    Logout as LogoutIcon,
    PersonOutline as PersonOutlineIcon,
} from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import LoginDialog from 'components/User/LoginDialog/LoginDialog';
import { useState } from 'react';
import { UserTypesWithGuestEnum } from 'types/UserTypesWithGuestEnum';
import { useServerTranslation } from 'hooks/useServerTranslation';
import CountryPicker from 'components/CountryPicker';
import useCustomerActions from '../../../../../hooks/useCustomerActions';
import useUser from '../../../../../stores/useCustomer';

export default function AccountMenuButtons() {
    const [openLogin, setOpenLogin] = useState(false);
    const { t } = useServerTranslation();
    const { clickFavourites, clickMyAccount, clickLogOut } = useCustomerActions();
    const isConsultant = useUser((state) => state.user?.user_type === UserTypesWithGuestEnum.Consultant);
    const isLoggedIn = useUser((state) => state.useLoggedIn());

    const openLoginDialog = () => {
        setOpenLogin(true);
    };

    return (
        <>
            <Box display="flex" justifyContent="center" gap={1}>
                {isLoggedIn && !isConsultant ? (
                    <>
                        <Button variant="black" onClick={clickFavourites}>
                            <FavoriteBorderIcon sx={{ marginRight: 1 }} />
                            {t('menu.favourites')}
                        </Button>
                        <Button variant="black" onClick={clickMyAccount}>
                            <PersonOutlineIcon sx={{ marginRight: 1 }} />
                            {t('menu.my-account')}
                        </Button>
                    </>
                ) : null}
                {isLoggedIn ? (
                    <Button onClick={clickLogOut} variant="black">
                        <LogoutIcon sx={{ marginRight: 1 }} />
                    </Button>
                ) : null}
                {!isLoggedIn ? (
                    <>
                        <CountryPicker />
                        <Button variant="black" onClick={openLoginDialog}>
                            <PersonOutlineIcon sx={{ marginRight: 1 }} />
                            {t('menu.log-in')}
                        </Button>
                    </>
                ) : null}
                {/* // TODO: Activate signup when Lesley is ready
                {!isSignedUp ? (
                    <Button
                    variant="black"
                    LinkComponent={NextLink}
                    href={signUpHref}
                    >
                        <PersonOutlineIcon sx={{ marginRight: 1 }} />
                        {t('menu.sign-up')}
                    </Button>
                ) : null} */}
            </Box>
            <LoginDialog open={openLogin} setOpen={setOpenLogin} />
        </>
    );
}
